import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Row, Col, CardBody, Card, Container, Button } from "reactstrap"
import DataTable from "react-data-table-component"
import { is_empty } from "../../config/validate"
import showToast from "../../components/Common/viewNotification"
import AreaForm from "./areaForm"
//redux
import { useSelector, useDispatch } from "react-redux"
import { withRouter } from "react-router-dom"

// actions
import { getAreasByUser, deleteArea } from "../../store/actions"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import SessionConfig from "../../config/session_config"
import Breadcrumbs from "../../components/Common/Breadcrumb"

const AreaUser = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const ref = useRef()

  const [currentUser, setCurrentUser] = useState(null)
  const [columns, setColumns] = useState([])
  const [auth] = useState(JSON.parse(sessionStorage.getItem("user")))
  const [selectedRows, setSelectedRows] = useState([])
  const [toggleCleared, setToggleCleared] = useState(false)

  document.title = t("area:title") + " | " + t("global:title")
  const { error, loading, areaByUser } = useSelector(state => {
    return {
      error: state.AreaUser.error,
      loading: state.AreaUser.loading,
      areaByUser: state.AreaUser.areaUser,
    }
  })

  useEffect(() => {
    document.getElementById("body").className = "backPage"
  }, [])
  
  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])

  const initColumns = () => {
    let col = [
      {
        name: t("area:name"),
        selector: row => row.area.name,
        sortable: true,
        grow: 2,
        reorder: true,
      },
      {
        name: t("area:cod"),
        selector: row => row.area.code,
        sortable: true,
        grow: 2,
        reorder: true,
      },
    ]
    setColumns(col)
  }
  const loadAreasByUser = user => {
    setCurrentUser(user)
    initColumns()
    dispatch(getAreasByUser(user?.id))
  }
  const deleteAreas = () => {
    setToggleCleared(!toggleCleared)
    dispatch(deleteArea(areaByUser, selectedRows, auth.id.user.username))
  }

  const changeTableSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows)
  }

  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("area:title")}
          />
          <Row>
            <Col md={6} lg={6} xl={3}>
              <AreaForm onLoad={loadAreasByUser} />
            </Col>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <label className="text-primary text-uppercase font-size-16">
                        <i className="fa fa-list font-size-18  me-1 " />
                        {t("area:area")}
                      </label>
                    </Col>
                    <Col>
                      <div className="text-sm-end">
                        {currentUser ? (
                          <Button onClick={deleteAreas} color="danger">
                            <i className=" fas fa-times-circle me-1 " />
                            {t("global:delete")}
                          </Button>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                  <DataTable
                    columns={columns}
                    data={currentUser ? areaByUser : []}
                    fixedHeader
                    fixedHeaderScrollHeight="500px"
                    dense
                    selectableRows
                    onSelectedRowsChange={changeTableSelect}
                    highlightOnHover
                    progressPending={loading}
                    progressComponent={<LinearIndeterminate />}
                    pointerOnHover={true}
                    clearSelectedRows={toggleCleared}
                    noDataComponent={t("tableOptions:noDataComponent")}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AreaUser)

AreaUser.propTypes = {
  history: PropTypes.object,
}
